// extracted by mini-css-extract-plugin
export default {"success":"ForgotPasswordCard_success__lRofz","headline":"ForgotPasswordCard_headline__H69AK","subheadline":"ForgotPasswordCard_subheadline__fqn7C"};